import { create } from "zustand";

interface UiState {
  sidebarExpanded: boolean;
  setSidebarExpanded: (expanded: boolean) => void;
}

const useUiState = create<UiState>((set) => ({
  sidebarExpanded: false,
  setSidebarExpanded: (expanded) => set({ sidebarExpanded: expanded }),
}));

export default useUiState;
